import * as React from "react";

import { Box, makeStyles, Theme } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CreateIcon from "@material-ui/icons/Create";
import DeleteIcon from "@material-ui/icons/Delete";
import clsx from "clsx";

import { useNormalizedBrandPaletteValues } from "client/hooks/useNormalizedBrandThemeValues";
import { MerchantCollections } from "client/lib/apt-merchant";

const useStyles = makeStyles((theme: Theme) => {
  const { error } = useNormalizedBrandPaletteValues(theme);

  return {
    actionButton: {
      marginLeft: theme.spacing(1.5),
    },
    formCollectionListItem: {
      padding: theme.spacing(1.5),
      "&:nth-of-type(odd)": {
        backgroundColor: "#EFF4FB",
      },
      "&:nth-of-type(even)": {
        backgroundColor: "#F9FBFD",
      },
    },
    formCollectionListItemErrorState: {
      border: `1px solid ${error}`,
    },
    iconButton: {
      padding: 0,
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
  };
});

interface ListItem {
  deleteHandler: () => void;
  editHandler: () => void;
  formCollectionListIndex: number;
  formCollectionType: keyof MerchantCollections;
  hasErrors: boolean;
  label: string;
}

export const FormCollectionListItem: React.FC<ListItem> = ({
  deleteHandler,
  editHandler,
  formCollectionListIndex,
  formCollectionType,
  hasErrors,
  label,
}) => {
  const classes = useStyles();
  return (
    <Box
      aria-invalid={hasErrors ? "true" : "false"}
      alignItems="center"
      className={clsx(classes.formCollectionListItem, {
        [classes.formCollectionListItemErrorState]: hasErrors,
      })}
      data-testid={`form-collection-${formCollectionType}${formCollectionListIndex}`}
      display="flex"
      justifyContent="space-between"
    >
      <Box>
        <strong>{label}</strong>
      </Box>
      <Box alignItems="center" display="flex">
        <IconButton
          aria-label={`edit-owner${formCollectionListIndex}`}
          className={classes.iconButton}
          color="secondary"
          disableRipple={true}
          disableFocusRipple={true}
          onClick={editHandler}
        >
          <CreateIcon className={classes.actionButton} />
        </IconButton>
        <IconButton
          aria-label={`delete-owner${formCollectionListIndex}`}
          className={classes.iconButton}
          color="secondary"
          disableRipple={true}
          disableFocusRipple={true}
          onClick={deleteHandler}
        >
          <DeleteIcon className={classes.actionButton} />
        </IconButton>
      </Box>
    </Box>
  );
};
